<template>
  <div>
    <el-image :src="require('@/assets/main/title.png')" class="title-icon"></el-image>
    <span class="title">户外光后台管理系统</span>
    <div class="header-right">
      <el-avatar v-if="!avatar" icon="el-icon-user-solid"></el-avatar>
      <el-avatar v-if="avatar" :src="avatar"></el-avatar>
      <el-dropdown>
        <span class="username">{{ username }}<i class="el-icon-arrow-down el-icon--right"></i></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="updatePwd">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出系统</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-menu v-if="showTop" :default-active="defaultIndex" @select="selectMenu" background-color="Transparent" text-color="#fff" mode="horizontal" active-text-color="#409EFF">
      <el-menu-item v-for="(menu, index) in menus" :key="index" :index="index + ''">
        <div slot="title" class="menu-top">
          <i v-if="!menu.icon" class="el-icon-menu"></i>
          <i v-else-if="menu.iconType === 0" :class="menu.icon"></i>
          <el-image v-else-if="menu.iconType === 1" :src="getImage(menu.icon)" fit="fit">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <i v-else class="el-icon-menu"></i>
          <div>{{ menu.name }}</div>
        </div>
      </el-menu-item>
    </el-menu>
    <UpdatePwd ref="updatePwd"/>
  </div>
</template>

<script>
import UpdatePwd from './UpdatePwd'

export default {
  name: 'Header',
  components: {UpdatePwd},
  props: {
    //父组件选中顶部菜单方法
    selectTopMenu: {
      type: Function
    }
  },
  data () {
    return {
      //当前登录用户信息
      user: {},
      //菜单
      menus: [],
      //默认显示菜单索引
      defaultIndex: '0',
      //菜单点击前选中的菜单
      prevIndex: '0',
      //显示用户名称
      username: '',
      //是否显示顶部菜单
      showTop: false,
      //头像
      avatar: ''
    }
  },
  methods: {
    //登出系统
    logout: function () {
      this.$axios.get('/login/logout').then(response => {
        //提示信息
        this.$message.success('退出成功')
        //移除存储的用户信息
        sessionStorage.removeItem('user')
        //跳转登录页面
        this.$router.push('/')
      })
    },
    //获取登录用户信息
    getLoginUser: function () {
      this.user = this.$utils.getUserInfo()
      this.username = this.user.name
      this.avatar = this.user.avatar ? this.$axios.defaults.baseURL + '/fileUpload/preview?path=' + this.user.avatar : ''
    },
    //获取菜单
    getMenus: function () {
      this.$axios.get('/sysMenu/selectByUserId', {
        params: {
          userId: this.user.id
        }
      }).then(response => {
        //菜单数据
        this.menus = this.$utils.convertTree(response)
        //默认选中
        if(this.menus && this.menus[this.defaultIndex]){
          this.selectTopMenu(this.menus[this.defaultIndex].children)
        }
      })
    },
    //选中菜单
    selectMenu: function(index, indexPath){
      //只有点击的和当前不同的菜单才执行后续操作
      if(index !== this.prevIndex){
        this.prevIndex = index
        this.selectTopMenu(this.menus[index].children)
      }
    },
    //修改密码
    updatePwd: function(){
      this.$refs.updatePwd.isUpdatePwdDialog = true
    },
    //图片加载
    getImage: function(icon){
      try {
        return require('@/assets/main/' + icon)
      } catch (e) {
        return ''
      }
    }
  },
  mounted () {
    //获取登录用户信息
    this.getLoginUser()
    //获取菜单
    this.getMenus()
  }
}
</script>

<style scoped>
.title-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  padding-top: 10px;
}

.title {
  padding-left: 50px;
}

.el-menu {
  float: right;
  height: 80px;
  margin-right: 280px;
}

.el-menu-item {
  height: 80px;
}

.el-menu-item:hover {
  background-color: #323540 !important;
}

.is-active {
  border-bottom-width: 4px !important;
}

.menu-top {
  text-align: center;
}

.menu-top .el-image {
  width: 35px;
  height: 35px;
  position: static;
}

.menu-top i {
  margin-right: unset;
  width: unset;
  font-size: 35px;
  color: white;
}

.menu-top div {
  height: 20px;
  line-height: 5px;
}

.header-right {
  float: right;
  margin-right: 20px;
}

.el-avatar {
  vertical-align: middle;
  background-color: #9eadcc;
}

.username {
  font-size: 16px;
  color: white;
  cursor: pointer;
}

.el-dropdown {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/main/Header.vue